// The module loading all necessary FusionCharts components in the recommended sequence
// Use this module instead of 'require'-ing FusionCharts directly

import sessionConstants from "csi/sessionConstants";

const FusionCharts = require('fusioncharts/fusioncharts');
const Charts = require('fusioncharts/fusioncharts.charts');
const Gantt = require('fusioncharts/fusioncharts.gantt');
Charts();
Gantt();

FusionCharts.options.license({
	key: sessionConstants.fusionChartsLicense,
	creditLabel: false,
 });

define([], function() {

	/* Centric 8 theme for Fusion Chart */

	/** Fusion Charts Debugger, uncomment to enable
	FusionCharts.debugger.outputTo(function (message) {
		console.log('---FC Debug:' + message);
	});
	FusionCharts.debugger.enable(true);
	/**/


	FusionCharts.register("theme", {
		name: "centrictheme",

		theme: {
			base: {
				chart: {
					paletteColors: "#3C94F0,#77D1D9,#35B261,#FCCD30,#F38B22,#E75E4F,#7A65E6",
					labelDisplay: "auto",
					baseFontColor: "#1D2129",
					baseFont: "Centric8",
					captionFontSize: "14",
					subcaptionFontBold: "0",
					subcaptionFontSize: "14",
					xAxisNameFontSize: "12",
					yAxisNameFontSize: "12",
					showBorder: "0",
					bgColor: "#ffffff",
					showShadow: "0",
					canvasBgColor: "#ffffff",
					showCanvasBorder: "0",
					useplotgradientcolor: "0",
					useRoundEdges: "0",
					showPlotBorder: "0",
					showAlternateHGridColor: "0",
					showAlternateVGridColor: "0",
					toolTipColor: "#ffffff",
					toolTipBorderThickness: "0",
					toolTipBgColor: "#1D2129",
					toolTipBgAlpha: "100",
					toolTipBorderRadius: "2",
					toolTipPadding: "5",
					legendBgAlpha: "0",
					legendBorderAlpha: "0",
					legendShadow: "0",
					legendItemFontSize: "10",
					legendItemFontColor: "#1D2129",
					legendCaptionFontSize: "10",
					divlineAlpha: "100",
					divlineColor: "#B5BCC7",
					divlineThickness: "1",
					divLineIsDashed: "1",
					divLineDashLen: "1",
					divLineGapLen: "1",
					scrollheight: "10",
					flatScrollBars: "1",
					scrollShowButtons: "0",
					scrollColor: "#C3C9D4",
					showHoverEffect: "1",
					valueFontSize: "10",
					showXAxisLine: "1",
					xAxisLineThickness: "1",
					xAxisLineColor: "#A3ABB8"
				},
				trendlines: [{
					"line": [{
						paletteColors: "#3C94F0,#77D1D9,#35B261,#FCCD30,#F38B22,#E75E4F,#7A65E6"
					}]
				}]
			},

			pie2d: {
				chart: {
					captionPadding: "15",
					placeValuesInside: "0",
					use3dlighting: "0",
					valueFontColor: "#8E96A3"
				},
				data: function(index, dataItem, dataLength) {
					return {
						alpha: 100 - (50 < dataLength ? Math.round(100 / Math.ceil(dataLength / 10)) : 20) * Math.floor(index / 10)
					};
				}
			},
			doughnut2d: {
				chart: {
					centerLabelFontSize: "12",
					centerLabelBold: "1",
					centerLabelFontColor: "#8E96A3",
					captionPadding: "15",
					placeValuesInside: "0",
					use3dlighting: "0",
					valueFontColor: "#8E96A3"
				},
				data: function(index, dataItem, dataLength) {
					return {
						alpha: 100 - (50 < dataLength ? Math.round(100 / Math.ceil(dataLength / 10)) : 20) * Math.floor(index / 10)
					};
				}
			},
			line: {
				chart: {
					lineThickness: "2",
					valueBgColor: "#DADFE8",
					valueBgAlpha: "100",
					valueBorderPadding: "1",
					valuePadding: "4",
					valueBorderRadius: "2",
					valueFontColor: "#1D2129"
				}
			},
			msline: {
				chart: {
					lineThickness: "2",
					valueBgColor: "#DADFE8",
					valueBgAlpha: "100",
					valueBorderPadding: "1",
					valuePadding: "4",
					valueBorderRadius: "2",
					valueFontColor: "#1D2129"
				}
			},
			column2d: {
				chart: {
					paletteColors: "#2D76D4",
					placeValuesInside: "0",
					plotFillAlpha: "80",
					valueFontColor: "#8E96A3"
				}
			},
			bar2d: {
				chart: {
					paletteColors: "#2D76D4",
					placeValuesInside: "0",
					plotFillAlpha: "80",
					valueFontColor: "#8E96A3"

				}
			},
			msbar2d: {
				chart: {
					placevaluesInside: "0",
					plotFillAlpha: "80",
					valueFontColor: "#8E96A3"
				}
			},
			area2d: {
				chart: {
					drawAnchors: "1",
					plotFillAlpha: "80",
					valueBgColor: "#DADFE8",
					valueBgAlpha: "100",
					valueBorderPadding: "1",
					valuePadding: "4",
					valueBorderRadius: "2",
					valueFontColor: "#1D2129"
				}
			},
			msarea: {
				chart: {
					drawAnchors: "1",
					plotFillAlpha: "60",
					valueBgColor: "#DADFE8",
					valueBgAlpha: "100",
					valueBorderPadding: "1",
					valuePadding: "4",
					valueBorderRadius: "2",
					valueFontColor: "#1D2129"
				}
			},
			mscolumn2d: {
				chart: {
					placeValuesInside: "0",
					plotFillAlpha: "80",
					valueFontColor: "#8E96A3"
				}
			},
			stackedcolumn2d: {
				chart: {
					plotFillAlpha: "80",
					valueFontColor: "#1D2129"
				}
			},
			stackedbar2d: {
				chart: {
					plotFillAlpha: "80",
					valueFontColor: "#1D2129"
				}
			},
			pareto2d: {
				chart: {
					lineColor: "#35B261",
					paletteColors: "#2D76D4",
					placeValuesInside: "0",
					plotFillAlpha: "80",
					showLineValues: "0",
					valueFontColor: "#8E96A3"
				}
			}
		}
	});

	// return a main object of FusionCharts
	return FusionCharts;
});
